(function () {
  'use strict';
  const tr = document.documentElement.lang.startsWith('tr');
  const prefix = 'dose-contact-ref:';
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } }
  function save(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} }
  function init(root) {
    root.querySelectorAll('form[data-dose-support-form]').forEach(function (form) {
      if (form.dataset.doseSupportReady) return;
      form.dataset.doseSupportReady = 'true';
      const key = prefix + form.id;
      const notice = form.querySelector('[data-dose-form-notice]');
      const status = form.querySelector('[data-dose-form-success]');
      const previous = read(key);
      if (status && previous && Date.now() - previous.at < 86400000) {
        const line = document.createElement('span');
        line.style.display = 'block';
        line.className = 'dose-form-reference';
        line.textContent = (tr ? 'Başvuru referansın: ' : 'Your request reference: ') + previous.ref;
        status.appendChild(line);
      }
      const order = form.querySelector('[data-dose-order-number]');
      const orderParam = new URLSearchParams(location.search).get('order');
      if (order && !order.value && orderParam && /^#?[A-Za-z0-9-]{1,30}$/.test(orderParam)) order.value = orderParam;
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) return;
        if (navigator.onLine === false) {
          event.preventDefault();
          if (notice) { notice.hidden = false; notice.textContent = tr ? 'İnternet bağlantın kesilmiş görünüyor. Bağlantını kontrol edip tekrar gönderebilirsin; yazdıkların bu sayfada duruyor.' : 'You appear to be offline. Check your connection and try again; your message is still on this page.'; notice.focus(); }
          return;
        }
        const field = form.querySelector('[data-dose-reference-input]');
        if (field) {
          const bytes = new Uint8Array(6);
          crypto.getRandomValues(bytes);
          const ref = 'DD-' + new Date().toISOString().slice(0,10).replace(/-/g,'') + '-' + Array.from(bytes, n => n.toString(16).padStart(2,'0')).join('').toUpperCase();
          field.value = ref;
          save(key, {ref:ref,at:Date.now()});
        }
        if (notice) notice.hidden = true;
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
